import type { FaireProductEntity } from "../../entity_types/product";

export const p_vqdw2748hj: FaireProductEntity = {
  token: "p_vqdw2748hj",
  type: "product",
  name: "fairytale watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/28077f006371c91553b1b633627e4c858bab9c5945e82dcba563cf65127f7df1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/71e0bd5c6dceeef5b17ea9493b8308420beb34569a1faf8d12691de0d796f254.jpeg",
    "https://cdn.faire.com/fastly/9fa3783dd01316c87a3400a8dd0c82df4af0fafc7b53c8db41833c99d295cc6e.jpeg",
    "https://cdn.faire.com/fastly/c675163cd3e03515e3d8ddbc4506cc1e626fc794cd3ceaf242bc419d827a5351.jpeg",
    "https://cdn.faire.com/fastly/a180a39cf198859462b9798f32d504e57628037afde0c94552fe686038ebedf7.jpeg",
    "https://cdn.faire.com/fastly/7840499386a5cfb2e6c4f11a9ebf83967f2f393e25c286def7c8f7e88cd0aabb.jpeg",
    "https://cdn.faire.com/fastly/068874e8c9a72476235b4a7eeff1da246b5b6da8380935f00b868388a72b2408.jpeg",
  ],
  priceDollars: 12,
  description:
    "A favorite for children's boutiques. Twelve storybook illustrations — a princess, castle, dragon, mermaid, fairy, unicorn, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it a favorite for young painters and the grown-ups who paint alongside them.\n\nStrong in children's, gift, and grandparent-gifting categories. Pairs naturally with the paint set and brushes for a complete birthday gift.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:11.104Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
